import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Card, CardActionArea, CardMedia, CardContent, Typography, Chip, Box } from '@mui/material';
import FavoriteIcon from '@mui/icons-material/Favorite';
import PersonIcon from '@mui/icons-material/Person';

function CardItem({ src, text, label, path, size, icon, title }) {
  const isLarge = size === 'large';

  // Icon mapping for bride and groom
  const getIcon = () => {
    if (icon === 'bride') {
      return <FavoriteIcon sx={{ fontSize: { xs: 40, sm: 50, md: 60 }, color: '#FF69B4' }} />;
    } else if (icon === 'groom') {
      return <PersonIcon sx={{ fontSize: { xs: 40, sm: 50, md: 60 }, color: '#4169E1' }} />;
    }
    return null;
  };

  return (
    <>
      <li className={`cards__item${isLarge ? ' cards__item--large' : ''}`}>
        <Card elevation={4} sx={{ borderRadius: 3, backgroundColor: '#FBF8F1', overflow: 'visible' }}>
          <CardActionArea component={RouterLink} to={path} sx={{ position: 'relative' }}>
            {/* Title and Icon Overlay at Top */}
            {title && (
              <Box
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  zIndex: 2,
                  background: 'linear-gradient(180deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.5) 60%, transparent 100%)',
                  backdropFilter: 'blur(5px)',
                  padding: { xs: 2, sm: 3, md: 4 },
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: 1
                }}
              >
                {/* Icon */}
                {getIcon()}

                {/* Large Title */}
                <Typography
                  variant="h4"
                  sx={{
                    color: '#fff',
                    fontWeight: 800,
                    textAlign: 'center',
                    fontSize: { xs: '1.3rem', sm: '1.8rem', md: '2.2rem' },
                    textShadow: '2px 2px 4px rgba(0,0,0,0.8)',
                    letterSpacing: '0.5px',
                    lineHeight: 1.2
                  }}
                >
                  {title}
                </Typography>
              </Box>
            )}

            {label && (
              <Chip
                label={label}
                color="primary"
                size="small"
                sx={{ position: 'absolute', zIndex: 1, left: 12, bottom: 12, borderRadius: 3 }}
              />
            )}
            <CardMedia
              component="img"
              image={src}
              alt={label || 'card image'}
              sx={{ objectFit: 'cover', height: isLarge ? { xs: 240, sm: 300, md: 360 } : 220 }}
            />
            <CardContent>
              <Typography variant={isLarge ? 'h6' : 'subtitle1'} color="text.primary">
                {text}
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
      </li>
    </>
  );
}

export default CardItem;
